import React, { PureComponent } from 'react';
import style from './index.less';
import cx from 'classnames';

/**
 * 点击链接
 */
export default class Link extends PureComponent {
  render() {
    let { children, className, clickEffect, ...restProps } = this.props;
    const clickEffectClassName = {
      opacity: style.opacity,
      brightness: style.brightness
    }[clickEffect];
    className = cx(style.link, className, clickEffectClassName);
    return (
      <a className={className} {...restProps}>
        {children}
      </a>
    );
  }
}

Link.defaultProps = {
  /**
   * clickEffect 有效值: opacity | brightness
   */
  clickEffect: 'opacity'
};



// WEBPACK FOOTER //
// ./src/components/link/index.js